<template>
<div
    class="test-question-edit-form"
>
    <tabs>
        <tab :name="trans.edit_form.question_tabs.editor_label" :selected="true">
            <question-editor-tab-form :question="question"/>
        </tab>
        <tab :name="trans.edit_form.question_tabs.parameters_label">
            <question-parameters-tab-form :question="question"/>
        </tab>
    </tabs>
    <button
        class="button is-info save-test-question"
        :class="{ 'is-loading': requestsProgress.question.update }"
        @click="save"
        :disabled="!isCanEdit"
    >
        {{ trans.edit_form.save_button }}
    </button>
</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Tabs from "../../../../utils/tabs/Tabs";
import Tab from "../../../../utils/tabs/Tab";
import QuestionEditorTabForm from "./tabs/QuestionEditorTabForm";
import QuestionParametersTabForm from "./tabs/QuestionParametersTabForm";

export default {
    name: "QuestionEditForm",
    components: {QuestionParametersTabForm, QuestionEditorTabForm, Tabs, Tab},
    props: {
        question: Object,
    },
    computed: {
        ...mapGetters('tests', [
            'trans',
            'requestsProgress',
            'isCanEdit',
        ])
    },
    methods: {
        ...mapActions('tests', [
            'updateTestQuestion'
        ]),
        save() {
            this.updateTestQuestion({
                questionId: this.question.hash_id,
                questionData: this.question,
            })
        },
    },
}
</script>

<style lang="scss">
@import 'resources/sass/variables';

.test-question-edit-form {
    width: 100%;
    font-size: 0.95rem;
    flex-direction: column;

    .save-test-question {
        margin: 25px 0 30px 0;
        height: 55px;
        width: 100%;
        border-radius: 6px;
    }
}


.bulma .tabs-container {
    .tabs {
        margin-bottom: 0 !important;
        font-size: inherit;

        ul {
            border: none;
        }

        li.is-active {
            border-radius: 6px 6px 0 0;

            a {
                background-color: #ECECEC;
                color: $tests-blue;
            }
        }

        a {
            border: none;
            color: $tests-grey;
            height: 45px;
            padding: 12px 20px 14px;
        }
    }

    .tabs-details {
        background: #ECECEC;
        border-radius: 0 6px 6px 6px;
        padding: 20px;

        .label {
            font-weight: 600;
            font-size: inherit;
            color: $black;
        }
    }
}
</style>
